const tabbableNode = /input|select|textarea|button|object/

function hidesContents(element: HTMLElement) {
  const zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) {
    return true
  }

  // Otherwise we need to check some styles
  const style = window.getComputedStyle(element)
  return zeroSize
    ? style.getPropertyValue("overflow") !== "visible"
    : style.getPropertyValue("display") === "none"
}

function visible(element: HTMLElement) {
  let parentElement: HTMLElement | null | ParentNode = element
  while (parentElement) {
    if (parentElement === document.body) {
      break
    }
    if (hidesContents(parentElement as HTMLElement)) {
      return false
    }
    parentElement = parentElement.parentNode
  }
  return true
}

export function focusable(element: HTMLElement, isTabIndexNotNaN: boolean) {
  const nodeName = element.nodeName.toLowerCase()
  const res =
    (tabbableNode.test(nodeName) && !element.getAttribute("disabled")) ||
    (nodeName === "a"
      ? element.getAttribute("href") || isTabIndexNotNaN
      : isTabIndexNotNaN)
  return res && visible(element)
}

export function tabbable(element: HTMLElement) {
  const tabIndex: string | null = element.getAttribute("tabindex")
  let modifiedTabIndex: number | undefined
  if (tabIndex === null) {
    modifiedTabIndex = undefined
  } else {
    modifiedTabIndex = Number(tabIndex)
  }
  return (
    (!modifiedTabIndex || modifiedTabIndex >= 0) &&
    focusable(element, !modifiedTabIndex)
  )
}

export default function findTabbableDescendants(element: HTMLElement) {
  const arrayOfTabbableElement: HTMLElement[] = []
  return arrayOfTabbableElement.slice
    .call(element.querySelectorAll("*"), 0)
    .filter(tabbable)
}
